export default __webpack_public_path__ + "static/media/icon_customerdb.ad1f72b1.svg";